import { createTranslationFile, createLanguage } from "@vocab/core/runtime";
const translations = createTranslationFile({
  en: createLanguage({ Menu: "Menu" }),
  th: createLanguage({ Menu: "เมนู" }),
  id: createLanguage({ Menu: "Menu" }),
  zh: createLanguage({ Menu: "選單" }),
  "en-AU": createLanguage({ Menu: "Menu" }),
  "en-HK": createLanguage({ Menu: "Menu" }),
  "en-ID": createLanguage({ Menu: "Menu" }),
  "en-MY": createLanguage({ Menu: "Menu" }),
  "en-NZ": createLanguage({ Menu: "Menu" }),
  "en-PH": createLanguage({ Menu: "Menu" }),
  "en-SG": createLanguage({ Menu: "Menu" }),
  "en-TH": createLanguage({ Menu: "Menu" }),
  "th-TH": createLanguage({ Menu: "เมนู" }),
  "id-ID": createLanguage({ Menu: "Menu" }),
  "zh-HK": createLanguage({ Menu: "選單" }),
  "en-PSEUDO": createLanguage({ Menu: "[Ṃẽẽกี้ǚǚ]" })
});
export {
  translations
};
